import lPainter from "./components//l-painter/l-painter.vue";

/* istanbul ignore next */
lPainter.install = function(Vue) {
  Vue.component(lPainter.name, lPainter);
};

export default lPainter;
